<tps-assistant-message [sender]="i18n.translate('assistant:tebisAssistant')()" [sentDate]="data().sentDate" [messageContent]="i18n.translate('assistant:orderCreatedMessage')()" role="assistant">
  <tps-windowed-router-link [url]="['/order', data().orderID].join('/')" [tabLabel]="getOrderTabLabel(data().orderID)">
    <ngt-link href="#" matIcon="note_alt">{{ data().orderID }}</ngt-link>
  </tps-windowed-router-link>
</tps-assistant-message>
